<template>
  <BaseExtractedDetails 
    :sections="sections" 
    :has-data="hasData"
    :data="data"
  />
</template>

<script>
import BaseExtractedDetails from './BaseExtractedDetails.vue'

export default {
  name: 'TradeLicenseDetails',
  components: {
    BaseExtractedDetails
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasData() {
      return this.data && Object.keys(this.data).length > 0;
    },
    
    sections() {
      if (!this.data) return [];
      
      return [
        // License Information
        {
          title: 'License Information',
          icon: 'las la-file-alt',
          type: 'info-grid',
          fields: [
            {
              key: 'license_info.license_number',
              label: 'License Number',
              format: 'text'
            },
            {
              key: 'license_info.trade_name_english',
              label: 'Trade Name (English)',
              format: 'text'
            },
            {
              key: 'license_info.legal_type',
              label: 'Legal Type',
              format: 'text'
            },
            {
              key: 'license_info.issue_date',
              label: 'Issue Date',
              format: 'date'
            },
            {
              key: 'license_info.expiry_date',
              label: 'Expiry Date',
              format: 'date'
            },
            {
              key: 'license_info.status',
              label: 'Status',
              format: 'text'
            },
            {
              key: 'license_info.license_type',
              label: 'License Type',
              format: 'text'
            },
            {
              key: 'license_info.issuing_authority',
              label: 'Issuing Authority',
              format: 'text'
            }
          ]
        },
        
        // Business Address
        {
          title: 'Business Address',
          icon: 'las la-map-marker-alt',
          type: 'info-grid',
          fields: [
            {
              key: 'business_address.address',
              label: 'Address',
              format: 'text',
              fullWidth: true
            },
            {
              key: 'business_address.po_box',
              label: 'PO Box',
              format: 'text'
            },
          ]
        },
        
        // Owner Details
        ...(this.data.owner_details && this.data.owner_details.length > 0 ? [{
          title: 'Owner Details',
          icon: 'las la-user',
          type: 'table',
          columns: [
            {
              key: 'owner_name',
              label: 'Owner Name',
              format: 'text'
            },
            {
              key: 'nationality',
              label: 'Nationality',
              format: 'text'
            },
            {
              key: 'ownership_percentage',
              label: 'Ownership %',
              format: 'text'
            },
            {
              key: 'role',
              label: 'Role',
              format: 'text'
            }
          ],
          data: this.data.owner_details
        }] : []),
        
        // Activities
        ...(this.data.activities && this.data.activities.length > 0 ? [{
          title: 'Business Activities',
          icon: 'las la-briefcase',
          type: 'table',
          columns: [
            {
              key: 'activity_name',
              label: 'Activity Name',
              format: 'text'
            },
            {
              key: 'activity_code',
              label: 'Activity Code',
              format: 'text'
            },
            {
              key: 'activity_group',
              label: 'Activity Group',
              format: 'text'
            }
          ],
          data: this.data.activities
        }] : []),
        
        // Manager Details
        ...(this.data.manager_details ? [{
          title: 'Manager Details',
          icon: 'las la-user-tie',
          type: 'info-grid',
          fields: [
            {
              key: 'manager_details.manager_name',
              label: 'Manager Name',
              format: 'text'
            },
            {
              key: 'manager_details.nationality',
              label: 'Nationality',
              format: 'text'
            },
            {
              key: 'manager_details.designation',
              label: 'Designation',
              format: 'text'
            }
          ]
        }] : []),
        
        // Contact Information
        ...(this.data.contact_info ? [{
          title: 'Contact Information',
          icon: 'las la-phone',
          type: 'info-grid',
          fields: [
            {
              key: 'contact_info.email',
              label: 'Email',
              format: 'text'
            },
            {
              key: 'contact_info.phone',
              label: 'Phone',
              format: 'text'
            }
          ]
        }] : [])
      ];
    }
  }
}
</script>
